import { ref } from 'vue';

/**
 * Session-expired circuit breaker (module-level singleton).
 *
 * When the session dies, every in-flight API call fails at once (401/403).
 * The first failure trips this flag and App.vue shows ONE blocking
 * SessionExpiredModal with a "Log In" button; every later failure is a no-op,
 * so the user never sees a stack of duplicate errors.
 *
 * No reset is needed: the modal's button dispatches `logOut`, which ends in
 * `window.location.replace('/sign-in')` — the full page reload clears this flag.
 */
export const sessionExpired = ref(false);
export const sessionExpiredMessage = ref('');

const DEFAULT_MESSAGE = 'Your session has expired. Please log in again to continue.';

export function triggerSessionExpired(message = DEFAULT_MESSAGE) {
  if (sessionExpired.value) return false; // already showing — stay silent
  sessionExpiredMessage.value = message;
  sessionExpired.value = true;
  return true;
}

export function isSessionExpired() {
  return sessionExpired.value;
}
